import { Box, Typography, useTheme } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";
import { useFormik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/useRedux";
import ArrowLeft from "../../../../../media/images/icons/arrow-left";
import BuildingSVG from "../../../../../media/images/icons/building-icon";
import CarCancle from "../../../../../media/images/icons/car-cancle";
import CarTimerIcon from "../../../../../media/images/icons/car-timer";
import ClockFillSVG from "../../../../../media/images/icons/clockfill";
import hourglassSVG from "../../../../../media/images/icons/hourglass.svg";
import InfoCircle from "../../../../../media/images/icons/info-circle";
import PeopleSVG from "../../../../../media/images/icons/people-svg";
import TruckFillSVG from "../../../../../media/images/icons/truck-fill";
import profileImage from "../../../../../media/images/profileImage.svg";
import {
  setDialogDescription,
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../redux/features/dialogSlice";
import { setDriverNobatQueueInfo } from "../../../../../redux/features/userSlice";
import { fetcherPost } from "../../../../../services/fetcher";
import { convertToJalali } from "../../../../../utils/functions";
import CarTagView from "../../../../components/CarTag";
import CustomButton from "../../../../components/CustomButton";
import CustomHelmet from "../../../../components/CustomHelmet";
import MobileHeader from "../../../../layout/DriverLayout/Header";
import CheckinCancelModal from "../components/CheckinCancelModal";

export default function TurnDetails() {
  const theme = useTheme();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const [cancleModal, setCancleModal] = useState(false);

  const { fullName, driverNobatQueueInfo, vehicleInfo } = useAppSelector(
    (state) => state.user
  );

  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const { trigger: postRevokeNobatByDriver } = useSWRMutation(
    [
      `/Nobat/RevokeNobatByDriver
`,
      localStorage.getItem("access_token"),
    ],
    fetcherPost,
    {
      onSuccess: async () => {
        dispatch(setOpenDialog(true));
        dispatch(setDialogStatus("success"));
        dispatch(setDialogTitle("لغو نوبت"));
        dispatch(setDialogDescription("نوبت شما با موفقیت لغو شد!"));
        setCancleModal(false);
        dispatch(
          setDriverNobatQueueInfo({
            salonInfo: null,
            nobatCode: 0,
            nobatDate: "",
          })
        );

        setTimeout(() => {
          dispatch(setOpenDialog(false));
          dispatch(setDialogDescription(""));
        }, 4000);
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      id: "",
    },
    onSubmit: (values) => {
      postRevokeNobatByDriver({ id: "" });
    },
  });
  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            اعلام حضور{" "}
          </Typography>
        }
      />
      <CustomHelmet title="اعلام حضور" />
      <CheckinCancelModal
        onOk={() => formik.handleSubmit()}
        open={cancleModal}
        setOpen={setCancleModal}
        onDismiss={() => setCancleModal(false)}
      />

      <Box
        sx={{
          paddingX: "8px",
        }}
      >
        <Box
          sx={{
            marginTop: "8px",
            backgroundColor: "bgColor.white",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "12px",
            borderStyle: "solid",
            borderColor: blueGrey[100],
            borderWidth: "1px",
            borderRadius: "16px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
              backgroundColor: theme.palette.secondary[50],
              borderRadius: "8px",
              paddingY: "8px",
            }}
          >
            <InfoCircle color={theme.palette.secondary.main} />
            <Typography
              sx={{
                color: "secondary.main",
              }}
            >
              شما یک نوبت فعال با مشخصات زیر دریافت کردید.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                style={{
                  width: "32px",
                  borderRadius: "50%",
                }}
                src={profileImage}
                alt=""
              />
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "600",
                }}
              >
                {fullName}
              </Typography>
            </Box>
            <CarTagView />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "primary.main",
              justifyContent: "center",
              paddingY: "8px",
              borderRadius: "8px",
              gap: "4px",
            }}
          >
            <CarTimerIcon color="#fff" />
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "16px",
                color: "#fff",
              }}
            >
              شماره اعلام حضور: {driverNobatQueueInfo.nobatCode}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: blueGrey[100],
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <TruckFillSVG
                color={themeMode === "light" ? grey[800] : "#fff"}
              />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                نوع بارگیر:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "secondary.main",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              {vehicleInfo?.loaderTypeGroup}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: blueGrey[100],
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <BuildingSVG color={themeMode === "light" ? grey[800] : "#fff"} />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                نام بازارگاه:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              {driverNobatQueueInfo.salonInfo?.name}
            </Typography>
          </Box>
          <Box
            sx={{
              borderColor: blueGrey[100],
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <PeopleSVG color={themeMode === "light" ? grey[800] : "#fff"} />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                تعداد اعلام حضور رانندگان:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              {driverNobatQueueInfo?.queueCount}
            </Typography>
          </Box>
          {/* <Box
            sx={{
              borderColor: blueGrey[400],
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={profileTickSVG} alt="" />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                موقعیت شما در صف:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              10{" "}
            </Typography>
          </Box> */}
          <Box
            sx={{
              borderColor: blueGrey[100],
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <ClockFillSVG
                color={themeMode === "light" ? grey[800] : "#fff"}
              />
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                تاریخ اعلام حضور:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              {convertToJalali(
                driverNobatQueueInfo.nobatDate
                  ? driverNobatQueueInfo.nobatDate
                  : ""
              )}
            </Typography>
          </Box>
          {/* <Box
            sx={{
              borderColor: "secondary.main",
              borderWidth: "0.5px",
              borderStyle: "solid",
              borderRadius: "10px",
              display: "flex",
              backgroundColor: theme.palette.secondary[50],
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={hourglassSVG} alt="" />
              <Typography
                sx={{
                  color: "secondary.main",
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                تاریخ اعتبار :{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "secondary.main",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              1402/12/01{" "}
            </Typography>
          </Box> */}
          <CustomButton
            // loading
            type="outlined"
            justifyContent="center"
            flexDirection="row-reverse"
            onClick={() => setCancleModal(true)}
            title="لغو "
            fWeight="700"
            bgColor="error.light"
            textColor="error.main"
            width="100%"
            fSize="16px"
            borderColor="error.main"
            px="10px"
            py="12px"
            borderRadius="10px"
            icon1={<CarCancle size={28} color={theme.palette.error.main} />}
          />
          <CustomButton
            // loading
            // flexDirection="row-reverse"
            onClick={() => navigate("../get-freight")}
            justifyContent="center"
            title="مشاهده و انتخاب بار"
            bgColor="secondary.main"
            fWeight="700"
            width="100%"
            fSize="16px"
            px="10px"
            py="12px"
            borderRadius="10px"
            icon2={<ArrowLeft size={32} />}
          />
        </Box>
      </Box>
    </>
  );
}
